module.exports = __webpack_public_path__ + "img/me.c6fe2d94.jpg";